import { AgeGroup, AGE_GROUP_LABELS } from '../types'

interface AgeGroupSelectorProps {
  value:    AgeGroup
  onChange: (value: AgeGroup) => void
}

const AGE_GROUPS: AgeGroup[] = ['tiny', 'young', 'middle']

const AGE_ICONS: Record<AgeGroup, string> = {
  tiny:   '🐣',
  young:  '🌱',
  middle: '🌟',
}

export default function AgeGroupSelector({ value, onChange }: AgeGroupSelectorProps) {
  return (
    <div>
      <label className="config-label">Age Group</label>
      <div className="flex gap-2" role="radiogroup" aria-label="Age group">
        {AGE_GROUPS.map((group) => (
          <button
            key={group}
            role="radio"
            aria-checked={value === group}
            onClick={() => onChange(group)}
            className={value === group ? 'sel-btn-active gap-1' : 'sel-btn gap-1'}
          >
            <span className="text-xl" aria-hidden>{AGE_ICONS[group]}</span>
            <span>{AGE_GROUP_LABELS[group]}</span>
          </button>
        ))}
      </div>
    </div>
  )
}
